import React from 'react'
import KpiPanel from './KpiPanel'
import NuevosUsuarios from './NuevosUsuarios'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid';
import { usuarioSelector } from '../../selectors/sessionSelector'

class PedidosContainer extends React.Component{

    constructor(props){
        super(props)

        this.state = {
            usuarioCargado: false,
        }
    }

    componentDidUpdate = () => {
        if(this.state.usuarioCargado === false && this.props.usuario !== undefined){
            this.setState({usuarioCargado: true}, () => {
                if(this.props.usuario.idRol === 2){
                    window.location.hash = '/Articulo'
                }
            })
        }
    }

    render() {

        return  <Grid container spacing={24}>
                    <Grid item xs={4}><KpiPanel/></Grid>
                    {/*<Grid item xs={6}><CarritosAbandonados/></Grid>*/}
                    <Grid item xs={8}><NuevosUsuarios/></Grid>
                    <Grid item xs={6}></Grid>
                </Grid>
    }
}

function mapStateToProps(state) {
	return {
        usuario: usuarioSelector(state),
	}
}

export default connect(mapStateToProps)(PedidosContainer)